<template>
  <div class="day" :class="[5,6].includes(day.position) ? 'bg-light' : '' ">
        <span v-if="day.selected" class="px-2 pt-1 selected">{{ day.number }}</span>
        <span v-else class="pl-2 pt-1" :class="day.other ? 'text-more-muted' : ''">{{ day.number }}</span>
  </div>
</template>

<script>
export default {
    props: {
        day: { Object, required:true },
    },
}
</script>

<style scoped>
.day {
    flex: 1;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
}
.day span {
    display: inline-block;
}
.text-more-muted {
    color: rgba(0, 0, 0, 0.3);
}
.selected {
    color: white;
    background-color: orange !important;
}
</style>